import { Box, Typography } from "@mui/material";
import LazyImage from "components/LazyImage";
import useWindowSizeV2 from "hooks/use-window-size-v2";
import { FC, Fragment, memo } from "react";

type Props = {};

const Component: FC<Props> = () => {
  const { isMobile } = useWindowSizeV2();

  return (
    <Fragment>
      {isMobile ? (
        <Box sx={{ display: "grid", placeContent: "center", width: "100%" }}>
          <LazyImage
            sx={{
              width: "100%",
              height: { xs: 300, md: 500 },
              borderRadius: "8.8px",
            }}
            width={1350}
            height={350}
            alt={`/assets/images/extra-service/extra-service-title.png`}
            loading="eager"
            objectFit="contain"
            src={"/assets/images/extra-service/extra-service-title.png"}
          />
          <LazyImage
            sx={{
              width: "100%",
              height: { xs: 300, md: 500 },
              borderRadius: "8.8px",
            }}
            width={180}
            height={180}
            alt={`/assets/images/extra-service/pc-worth-extra-service-seal.png`}
            loading="eager"
            objectFit="contain"
            src={"/assets/images/extra-service/pc-worth-extra-service-seal.png"}
          />
        </Box>
      ) : (
        <Box
          sx={{
            width: "100%",
            display: "flex",
            alignItems: "center",
          }}
        >
          <LazyImage
            sx={{
              width: "100%",
              borderRadius: "8.8px",
              border: "2px solid red",
            }}
            width={650}
            height={350}
            alt={`/assets/images/extra-service/pc-worth-extra-service-banner.png`}
            loading="eager"
            objectFit="contain"
            src={"/assets/images/extra-service/extra-service-title-lg.png"}
          />
          <div style={{ marginLeft: "8rem" }}>
            <LazyImage
              sx={{
                width: "100%",
                borderRadius: "8.8px",
              }}
              width={280}
              height={280}
              alt={`/assets/images/extra-service/pc-worth-extra-service-banner.png`}
              loading="eager"
              objectFit="cover"
              src={
                "/assets/images/extra-service/pc-worth-extra-service-seal.png"
              }
            />
          </div>
        </Box>
      )}
      <Box mt={3}>
        <Typography
          fontSize={{ xs: "16px", lg: "24px" }}
          textAlign={"justify"}
          lineHeight={{ xs: "32px", lg: "42px" }}
        >
          The <strong>PC Worth Extra Service Seal</strong> symbolizes our
          commitment to delivering exceptional quality and customer protection.
          Displayed on eligible products, this seal guarantees a comprehensive{" "}
          <strong>2-year warranty</strong>, allowing customers to shop with
          confidence knowing that any factory defects will be addressed
          promptly. It also signifies our <strong>30-day replacement</strong>{" "}
          policy, which ensures hassle-free returns for defective items, and
          highlights our dedication to{" "}
          <strong>lifetime customer service</strong>, providing ongoing support
          and assistance long after the purchase. By choosing products with the{" "}
          <strong>PC Worth Extra Service Seal</strong>, customers can trust they
          are receiving not just superior products, but also reliable support
          and peace of mind with every purchase.
        </Typography>
      </Box>
    </Fragment>
  );
};

export const ExtraServiceMainHeader = memo(Component);
